module.exports = __webpack_public_path__ + "img/62.aa932fe1.jpg";